import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Overlays the target selector inside the selector viewport once a target is chosen. */
export const SelectionPanelRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  inset: 0,
  minHeight: 0,
  gap: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
}));

export const DateSelector = styled(Stack)(({ theme }) => ({
  flexShrink: 0,
  gap: theme.spacing(0.5),
}));

export const DateSelectorHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const SeriesSelectorContainer = styled(Box)({
  flex: 1,
  minHeight: 0,
});
